import React from 'react';
import {
  Button,
  Typography,
  Card,
} from '@mui/material';
import Cookies from 'universal-cookie';
import { useTranslation } from 'react-i18next';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { useNavigate, useLocation } from 'react-router-dom';
import googleLogo from 'files/googleLogo.png';
import AcceptGTCU from './AcceptGTCU';

const GTCU_COOKIE_NAME = 'agreed-to-general-terms-organizations-ws';

export default function SocialSigninCard(props) {
  const {
    signinCallback = () => {},
  } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();
  const analytics = getAnalytics();
  const provider = new GoogleAuthProvider();
  const afterSignInRedirect = location.state?.afterSignInRedirect;
  const ourSignInWithPopup = () => signInWithPopup(auth, provider);
  const cookies = new Cookies();
  const [acceptedGTCU, setacceptedGTCU] = React.useState(false);
  const [showGTCUError, setshowGTCUError] = React.useState(false);

  const signIn = async () => {
    if (!acceptedGTCU) {
      return setshowGTCUError(true);
    }
    localStorage.setItem(GTCU_COOKIE_NAME, 'true');
    cookies.set(GTCU_COOKIE_NAME, 'true');
    try {
      const result = await ourSignInWithPopup();
      signinCallback();
      if (!afterSignInRedirect) {
        navigate('/');
      } else {
        navigate(afterSignInRedirect);
      }
      return result;
    } catch (error) {
      logEvent(analytics, 'login_error', {
        error_message: error.message,
      });
    }
    return null;
  };
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        p: 3,
        gap: 1,
        width: { xs: '100%', sm: '88%' },
        maxWidth: 670,
      }}
    >
      <Typography component="span" variant="subtitle1" gutterBottom>
        {t('signin.google_login')}
      </Typography>
      <AcceptGTCU
        acceptedGTCU={acceptedGTCU}
        setacceptedGTCU={setacceptedGTCU}
        showGTCUError={showGTCUError}
        setshowGTCUError={setshowGTCUError}
      />
      <Button
        variant="contained"
        color="inherit"
        onClick={signIn}
      >
        <img style={{ width: 20, marginRight: 5 }} src={googleLogo} alt="Google Labox" />
        {t('signin.login')}
      </Button>
    </Card>
  );
}
